module.exports = __webpack_public_path__ + "static/pic18-b4cbc916b96739e3869d1abc879380dd.png";